﻿import 'owl.carousel';

shvenergy.quoteresultCarousel = (function ($) {
    "use strict";

    var carousels = $(".owl-carousel");

    var carouselResponsiveOptions3Plus = {
        stagePadding: 32,
        loop: false,
        margin: 8,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2,
                margin: 16
            },
            1024: {
                items: 3,
                stagePadding: 0,
                margin: 32
            }
        }
    };

    var carouselResponsiveOptions2 = {
        stagePadding: 32,
        loop: false,
        margin: 8,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2,
                margin: 16
            },
            1024: {
                margin: 32
            }
        }
    };

    var carouselResponsiveOptions1 = {
        stagePadding: 16,
        loop: false,
        margin: 0,
        items: 1
    };

    function initCarousel() {

        var owlContainer = $('.owl-carousel');
        var owlItemsTotal = owlContainer.find('.item').length;
        var owlBestIndex = owlContainer.find('.item.is-best').length > 0 ? owlContainer.find('.item.is-best').index() : 0;
        
        var owlPosition;
        var owlItemsShown;
        
        if (owlItemsTotal == 1) {
            owlContainer.owlCarousel(carouselResponsiveOptions1);
        } else if (owlItemsTotal == 2) {
            owlPosition = owlBestIndex;
            owlContainer.owlCarousel(carouselResponsiveOptions2).trigger('to.owl.carousel', owlPosition);
        } else {
            if ($(window).width() < 600) {
                owlItemsShown = 1;
            } else if ($(window).width() >= 600 && $(window).width() < 1024) {
                owlItemsShown = 2;
            } else if ($(window).width() >= 1024) {
                owlItemsShown = 3;
            }
            owlPosition = Math.ceil(((owlBestIndex + 1) / owlItemsShown) - 1);
            owlContainer.owlCarousel(carouselResponsiveOptions3Plus).trigger('to.owl.carousel', owlPosition);
        }

    }

    function init() {

        //carousel
        if (carousels.length) {

            initCarousel();
        }

    }

    init();

})(jQuery);